var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-loader",style:({ transform: ("scale(" + _vm.scale + ")") })},[_c('div',{staticClass:"loader",style:({ '--loader-color': _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }